// extracted by mini-css-extract-plugin
module.exports = {"widget":"styles_widget__3JquQ","header":"styles_header__10qCM","icons":"styles_icons__2PM36","content":"styles_content__30XvR","spinner":"styles_spinner__3SuXC"};